
import { map } from 'rxjs/operators';
import { Company } from '../company/company.models';
import { Injectable, EventEmitter } from '@angular/core';
import { Http, URLSearchParams, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs';
import { CustomerStatus, Customer, CustomerType } from '.././customer/customer.models';
import { WOPriority, WOCategory, WOWorkTask, WOWorkType, PriorityListEntity, WOCalendarSlot, Customerlookupdetails, Email, BOQPartsEntity, LinkedWorkOrders, JobStatusReasonEntity } from './work-order-models';
import { API } from '.././core/app-config';
import {
    Customerdetails, CustomerDetailsListEntity, RecentWorkOrder, CustomerEntity, ValidEquipment,
    CustomerAddressDetails, CountryList, RefConfigvalue, CustomerContactDetails, RefRegion, Specialinfo,
    equipmentList, workOrderDetails, submitworkOrderDetails, AppointSlotReserve, CustomerTypesEntity, TimezoneEntity, woJobCFModel,
    WoStatusComp, Filterworkorder, ManageWorkOrderEntity, WorkTypesEntity, Vendor, Wo_JobDetails, AupWoAppointment, TechWorkSchFilter, TechWorkSchedule,
    CalendarSlots, CalendarTimeSlots, Technician, WoJobAdd, AddEditWoJobEntity, WorkOrderHistoryEntity, OnHoldStatus, ManageWorkOrderList, ManageWoListFilterEntity, WorkCategory, SchedulingPreference, ClosurePendingDetails, Wojobstatus, CancelWOstatus,
    PartLookupFilter, BrandList, ModelList, AllocatePart, SerialNumber, SpErrors, PartRequest, woJobEditCFModel, PartRequestEntity,
    PartReqStatus, CompanyWeekends, DispatchSetting, Holiday, SerialNumberCount, updateworkOrderDetail, UpdateWorkorderCFModel, WoSLADetails, WoJobSLAHistoryEntityList, SLAEntity, Config
    , SmslogEntity, TransferHistList, TransferHistory, TaxGroup, GetSMSLogSearch, GetSMSLogList, Pagination, CoreReturnStatus,
    CPUpdateDetails, CPStatusReasonDD, RefCPRequestStatusComp, RefOEMPartReqType, Logo, BusinessHour, CTBusinessHour, CustomerBusinessHour, SmsLogReceived, GetEMailLogList

} from './work-order-models';

import { Country, FPResponse, GlobalInfo,ContractType, PagerList, ProjectDetailsPanelEntity, JobStatusPopupInputSearchEntity, ResponseJobStatusPopupList } from '../shared/shared.model';
import { CustomFieldsConfiguration } from '../shared/custom-fields/custom-fields-models';
import { PricingModel, Pricing, WoEquipmentTab, PaymentDetails, EquipmentEntity, CustomerTimeZone, FileDetails } from '.././technician/technician-jobs/technician-jobs.models';
import { IOTWebhookEntity } from './iot-alerts/iot-models';
import { StatusReasonEntity } from './manage-work-order/details/status-reason-popup/status-reason.model';
import { UserRoles } from '../technician/inhouse-jobs/inhouse-job.model';
import { Checklist } from './work-order-master/workordermaster.models';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class WoService {

    constructor(private http: Http, private httpClient: HttpClient) { }

    linkedWo: EventEmitter<any> = new EventEmitter();

    getContacts(custId: any): Observable<any> {
        return this.http.get(API.WOCONTACT + custId).pipe(map(res => res.json()));
    }

    getPriceTypes() {
        return this.http.get(API.WOPRICETYPE).pipe(map(res => res.json()));
    }

    saveWorkOrder(wo: any) {
        var result = this.http.post(API.WOSAVE, wo).pipe(map(res => res.json()));
        return result;
    }
    getCustomFields(eid: number, pid: number) {
        var result = this.http.get(API.CUSTOMFILEDS + "?eid=" + eid + "&pid=" + pid).pipe(map(res => res.json()));
        return result;
    }
    getCustomerName(): Observable<string[]> {
        var result = this.http.get(API.CUSTOMERNAMES).pipe(map(res => res.json()));
        return result;
    }


    /**T.Vignesh*/
    /**Create WorkOrder Services */
    customerlookup(CustomerId: number, keyword: string) {
        return this.http.get(API.CUSTOMER + "/CustomerLookup/" + CustomerId + "/" + keyword).pipe(map(res => res.json()));
    }
    /**Customer Lookup API */
    searchCustomers(customerdetail: Customerdetails): Observable<CustomerDetailsListEntity> {
        return this.http.post(API.CUSTOMER + "/GetCustomerList", customerdetail).pipe(map(res => res.json()));
    }
    /**Customer Recent Orders API */
    recentOrders(CompanyId: number, CustomerId: number, LoginId: number, SearchKey: number, RecCount: number, RecordDays: number) {
        return this.http.get(API.WORKORDER + "/GetRecentOrders/" + CompanyId + "/" + CustomerId + "/" + LoginId + "/" + SearchKey + "/" + RecCount + "/" + RecordDays).pipe(map(resp => resp.json()));
    }
    //GetWorkOrderHistoryDetails
    GetWorkOrderHistoryDetails(CompanyId: number, WoNumber: string, WojobId: number, SearchKey: number, totimezone: number, loginId: number) {
        return this.http.get(API.WORKORDER + "/GetWorkOrderHistoryDetails?CompanyId=" + CompanyId + "&WoNumber=" + WoNumber + "&WojobId=" + WojobId + "&SearchKey=" + SearchKey + "&totimezone=" + totimezone + "&loginId=" + loginId).pipe(map(resp => resp.json()));
    }
    /**Get Customer Details After Autocomplete  API */
    GetCustomerDetails(CustomerId: number, CompanyId: number) {
        return this.http.get(API.CUSTOMER + "/GetCustomerDetails/" + CustomerId + "/" + CompanyId).pipe(map(resp => resp.json()));
    }
    /**Get Customer Address and Contact for Carousel */
    GetCustomerAddress(CompanyID: number, CustomerId: number, AddressTypeId: number) {
        return this.http.get(API.CUSTOMER + "/GetCustomerAddress/" + CompanyID + "/" + CustomerId + "/" + AddressTypeId).pipe(map(resp => resp.json()));
    }
    //Get woaddress  balamurugan m 21-06-2017
    GetWoAddressDetails(CustomerId: number, CompanyId: number) {
        return this.http.get(API.CUSTOMER + "/GetCustomerDetails/" + CustomerId + "/" + CompanyId).pipe(map(resp => resp.json()));
    }
    /**Get Wo Address and Contact for Carousel  balamurugan m 21-06-2017 */
    GetWoAddress(CompanyId: number, WorkOrderId: number, AddressTypeId: number, CustomerId: number) {
        return this.http.get(API.WORKORDER + "/GetWoAddressDetails/" + CompanyId + "/" + WorkOrderId + "/" + AddressTypeId + "/" + CustomerId).pipe(map(resp => resp.json()));
    }
    /**Get Country List for Dropdown */
    GetCountryList(IsActive: number, CompanyId: number) {
        return this.http.get(API.REGION + "/GetCountry/" + IsActive + "/" + CompanyId).pipe(map(resp => resp.json()));
    }
    /**Save Customer Address */
    AddCustomerAddress(customeraddress: CustomerAddressDetails): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + "/AddCustomerAddress", customeraddress).pipe(map(resp => resp.json()));
    }
    /** Edit Customer Address */
    EditCustomerAddress(customeraddress: CustomerAddressDetails): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + "/EditCustomerAddress", customeraddress).pipe(map(resp => resp.json()));
    }
    /**Save Customer Contact */
    AddCustomerContact(customercontact: CustomerContactDetails): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + "/AddCustomerContact", customercontact).pipe(map(resp => resp.json()));
    }
    /**Edit Customer Contact */
    EditCustomerContact(customercontact: CustomerContactDetails): Observable<FPResponse> {
        return this.http.put(API.CUSTOMER + "/UpdateCustomerContact", customercontact).pipe(map(resp => resp.json()));
    }
    /**Get contact type,Title */
    GetConfigType(CompanyId: number, ConfigMasterId: number) {
        return this.http.get(API.CUSTOMER + "/GetConfigType/" + CompanyId + "/" + ConfigMasterId).pipe(map(resp => resp.json()));
    }
    /**Get  Region List for Dropdown*/
    GetRegionList(CompanyId: number) {
        return this.http.get(API.CUSTOMER + "/GetRegionList/" + CompanyId).pipe(map(resp => resp.json()));
    }
    /**Get Customer Notes & Instructions */
    GetCustomerNotes(CompanyId: number, CustomerId: number, NotesMasterId: number) {
        return this.http.get(API.WORKORDER + "/GetCustomerNotes/" + CompanyId + "/" + CustomerId + "/" + NotesMasterId).pipe(map(resp => resp.json()));
    }

    /**Get Customer Notes & Instructions */
    GetManageWoCustomerNotes(CompanyId: number, CustomerId: number, NotesMasterId: string, TimeZoneId: number, WoId: number) {
        return this.http.get(API.WORKORDER + "/GetManageWoCustomerNotes/" + CompanyId + "/" + CustomerId + "/" + NotesMasterId + "/" + TimeZoneId + "/" + WoId).pipe(
            map(resp => resp.json()));
    }

    /**Save Special Notes */
    AddCustomerNotes(Notes: Specialinfo) {
        return this.http.post(API.WORKORDER + "/InsertCustomerNotes", Notes).pipe(map(resp => resp.json()));
    }
    /**Update Special Notes*/
    EditCustomerNotes(Notes: Specialinfo) {
        return this.http.put(API.WORKORDER + "/UpdateCustomerNotes", Notes).pipe(map(resp => resp.json()));
    }
    /**Delet Special Notes*/
    DeleteCustomerNotes(CompanyId: number, NotesId: number) {
        return this.http.delete(API.WORKORDER + "/DeleteCustomerNotes/" + CompanyId + "/" + NotesId).pipe(map(resp => resp.json()));
    }
    /** End Create WorkORder Services */



    /**Work Order Equipment */
    getCustomerEquipment(CompanyID: number, CustomerId: number[], CustomerAddressId: number) {
        return this.http.get(API.CUSTOMER + "/GetEquipments/" + CompanyID + "/" + CustomerId + "/" + CustomerAddressId).pipe(map(res => res.json()));
    }
    validateEquipment(CompanyId: number, BrandId: number, ModelId: number, SerialNo: string, custequipId: number, Priority: number) {
        return this.http.get(API.WORKORDER + "/ValidateEquipment/" + CompanyId + "/" + BrandId + "/" + ModelId + "/" + SerialNo + "/" + custequipId + "/" + Priority).pipe(map(res => res.json()));
    }
    validateEquipments(ValidEquipment: ValidEquipment) {
        return this.http.put(API.WORKORDER + "/ValidateEquipment", ValidEquipment).pipe(map(res => res.json()));
    }
    getBrandId(CompanyId: number, BrandId: number, CreatedBy: number) {
        return this.http.get(API.WORKORDER + "/GetBrand/" + CompanyId + "/" + BrandId + "/" + CreatedBy).pipe(map(res => res.json()));
    }
    getModelId(CompanyId: number, BrandId: number, ModelId: number, CreatedBy: number) {
        return this.http.get(API.WORKORDER + "/GetModel/" + CompanyId + "/" + BrandId + "/" + ModelId + "/" + CreatedBy).pipe(map(res => res.json()));
    }
    getWorkCategory(companyId: number) {
        return this.http.get(API.WORKORDERMAS + "/GetWorkCategoryDetails" + "?CompanyId=" + companyId + "&isActive=1").pipe(map(res => res.json()));
    }
    getPriorities(CompanyId: number): Observable<WOPriority[]> {
        return this.http.get(API.WOPRIORITY + "/GetPriorities/" + CompanyId).pipe(map(res => res.json()));
    }
    GetContractType(CompanyId: number): Observable<ContractType[]> {
        return this.http.get(API.MODEL + '/GetContract/' + CompanyId).pipe(map(res => res.json()));
    }
    getWoType(companyId: number, WoCategoryId: number): Observable<WOWorkType[]> {
        return this.http.get(API.WORKORDERMAS + "/GetAllWorkType" + "?CompanyId=" + companyId + "&WoCategoryId=" + WoCategoryId).pipe(map(res => res.json()));
    }
    getWoTask(companyId: number, WoTypeId: number): Observable<WOWorkTask[]> {
        return this.http.get(API.WORKORDERMAS + "/GetAllWorkTask" + "?CompanyId=" + companyId + "&WorkTypeId=" + WoTypeId).pipe(map(res => res.json()));
    }
    getAppointmentCalendar(companyId: number, LoginId: number, VendorId: number, ZipCode: string, Preferdate: string,
        WoTaskIds: string[], lat: number, long: number, Count: number, RegionId: number, StateId: number, CountryId: number, CustomerId: number, ProjectId: number, JobDuration?: number) {
        return this.http.get(API.SCHEDULING + "/GetAppointmentCalendar" + "?CompanyId=" + companyId + "&LoginId=" + LoginId + "&VendorId="
            + VendorId + "&ZipCode=" + ZipCode + "&Preferdate=" + Preferdate + "&WoTaskIds=" + WoTaskIds + "&Latitude=" + lat + "&Longitude=" + long + "&Count=" + Count + "&RegionId=" + RegionId + "&CountryId=" + CountryId + "&StateId=" + StateId + "&CustomerId=" + CustomerId + "&ProjectId=" + ProjectId + "&JobDuration=" + JobDuration).pipe(map(res => res.json()));
    }
    calendarAppointSlot(companyId: number, LoginId: number, zipcode: string, reserveDate: string, slotId: number, techScheduleId: number, startTime: string, WoTaskIds: string[], RegionId: number, StateId: number, CountryId: number, lat: number, long: number, CustomerId: number, ProjectId: number, PiSourceId?: number, JobDuration?: number) {
        return this.http.get(API.SCHEDULING + "/CalendarAppointSlot" + "?CompanyId=" + companyId + "&LoginId=" + LoginId + "&zipcode=" + zipcode + "&reserveDate=" +
            reserveDate + "&slotId=" + slotId + "&techScheduleId=" + techScheduleId + "&startTime=" + startTime + "&WoTaskIds=" + WoTaskIds + "&RegionId=" + RegionId + "&CountryId=" + CountryId + "&StateId=" + StateId + "&Latitude=" + lat + "&Longitude=" + long + "&CustomerId=" + CustomerId + "&ProjectId=" + ProjectId + "&JobDuration=" + JobDuration).pipe(map(res => res.json()));
    }

    RemoveAppointment(companyId: number, LoginId: number, reserveId: number) {
        return this.http.get(API.SCHEDULING + "/RemoveAppointment" + "?CompanyId=" + companyId + "&LoginId=" + LoginId + "&reserveId=" + reserveId).pipe(map(res => res.json()));
    }

    getTimeSlot(companyId: number): Observable<CalendarSlots[]> {
        return this.http.get(API.WORKORDER + "/GetPreferredSlot" + "/" + companyId).pipe(map(res => res.json()));
    }

    getPreferredTimeSlot(companyId: number): Observable<CalendarTimeSlots[]> {
        return this.http.get(API.WORKORDER + "/preferredTimeSlot" + "/" + companyId).pipe(map(res => res.json()));
    }
    /**Update Existing Equipment */
    UpdateEquipments(CompanyID: number, CustomerId: number, TagNo: string, Description: string, CustomerEquipmentId: number) {
        return this.http.get(API.CUSTOMER + "/UpdateEquipments?CompanyId=" + CompanyID + "&CustomerId" + CustomerId + "&Description" + Description + "&CustomerEquipmentId" + CustomerEquipmentId).pipe(map(resp => resp.json()));
    }
    /**Create Work Order Final Submit API */
    CreateWorkOrder(workOrderDetaillist: submitworkOrderDetails) {
        return this.http.post(API.WORKORDER + "/CreateWorkOrder/", workOrderDetaillist).pipe(map(resp => resp.json()));
    }

    /**Manage WorkOrder API's */
    /**Dropdown API's */
    getCustomerType(CompanyId: number) {
        return this.http.get(API.CUSTOMER + "/GetCustomerTypes/" + CompanyId).pipe(map(resp => resp.json()));
    }
    //Based on multi country purpose changed the  code Company country 23/02/2018
    // getTimeZone(LoginId: number,CompanyId: number, CountryId: number) {
    //     return this.http.get(API.USER + "/GetTimeZone/" + LoginId + "/" + CompanyId + "/" + CountryId).map(resp => resp.json());
    // }
    getTimeZone(LoginId: number, CompanyId: number) {
        return this.http.get(API.USER + "/GetTimeZone/" + LoginId + "/" + CompanyId).pipe(map(resp => resp.json()));
    }
    //Based on multi country purpose changed the  code Company country 23/02/2018
    getwoStatus(CompanyId: number) {
        return this.http.get(API.WORKORDER + "/GetWoStatusComp/" + CompanyId).pipe(map(resp => resp.json()));
    }

    getWorkOrderDetails(filterss: Filterworkorder) {
        return this.http.post(API.WORKORDER + "/MangeWorkOrder", filterss).pipe(map(resp => resp.json()));
    }
    getWorkOrderExcel(WoFilters: ManageWoListFilterEntity) {
        return this.http.post(API.WORKORDER + "/WorkOrderExcelDownload/", WoFilters, { responseType: ResponseContentType.Blob }).pipe();
    }

    getWorkType(CompanyId: number) {
        return this.http.get(API.WORKORDERMAS + "/GetWorkType/" + CompanyId).pipe(map(resp => resp.json()));
    }
    GetWorkCategory(CompanyId: number) {
        return this.http.get(API.WORKORDERMAS + "/GetWorkCategory/" + CompanyId).pipe(map(resp => resp.json()));
    }
    getvendors(LoginId: number, CompanyId: number) {
        return this.http.get(API.VENDOR + "/GetVendor/" + LoginId + "/" + CompanyId).pipe(map(resp => resp.json()));
    }
    //Get all job details of workorder
    getWoJobDetails(CompanyId: number, woId: number): Observable<Wo_JobDetails[]> {
        return this.http.get(API.WORKORDER + "/GetWoJobDetails/" + CompanyId + "/" + woId).pipe(map(resp => resp.json()));
    }

    getWoPricing(CompanyId: number, WorkOrderId: number) {
        return this.http.get(API.WORKORDER + "/GetWoPriceDetails?CompanyId=" + CompanyId + "&WorkOrderId=" + WorkOrderId).pipe(map(resp => resp.json()));
    }
    getWoSLAHistory(CompanyId: number, WoId: number, WoJobId: number) {
        return this.http.get(API.WORKORDER + "/GetSLAHistory?CompanyId=" + CompanyId + "&WoId=" + WoId + "&WoJobId=" + WoJobId).pipe(map(resp => resp.json()));
    }
    getWoSLApageHistory(woSLAdetails: WoSLADetails): Observable<WoJobSLAHistoryEntityList> {
        return this.http.post(API.WORKORDER + "/GetSLAHistoryPageList/", woSLAdetails).pipe(map(res => res.json()));
    }
    getWoEquipment(CompanyId: number, WorkOrderId: number, Customerid: number) {
        return this.http.get(API.WORKORDER + "/GetWoEquipmentDetails?CompanyId=" + CompanyId + "&WorkOrderId=" + WorkOrderId + "&Customerid=" + Customerid).pipe(map(resp => resp.json()));
    }
    //AutoScheduleAppointment
    autoScheduleAppointment(PiCompanyId: number, PiloginId: number, PiWoJobId: number, PiSourceId?: number) {
        return this.http.post(API.WORKORDER + "/AutoScheduleAppointment/" + PiCompanyId + "/" + PiloginId + "/" + PiWoJobId + "/" + PiSourceId, {}).pipe(map(resp => resp.json()));
    }
    //CancelAppointment
    cancelAppointment(PiCompanyId: number, PiloginId: number, PiWoJobId: number, PiCancelReasonId: number, PiSourceId: number) {
        return this.http.post(API.WORKORDER + "/CancelAppointment/" + PiCompanyId + "/" + PiloginId + "/" + PiWoJobId + "/" + PiCancelReasonId + "/" + PiSourceId, {}).pipe(map(resp => resp.json()));
    }
    //ScheduleAppointment
    scheduleAppointment(aupWoAppointment: AupWoAppointment) {
        return this.http.post(API.WORKORDER + "/ScheduleAppointment", aupWoAppointment).pipe(map(resp => resp.json()));
    }

    getWoPaymentDetails(CompanyId: number, WorkOrderId: number) {
        return this.http.get(API.WORKORDER + "/GetWoPaymentData?CompanyId=" + CompanyId + "&WorkOrderId=" + WorkOrderId).pipe(map(resp => resp.json()));
    }
    //GetTechWorkSchedule
    getTechWorkSchedule(techWorkSchFilter: TechWorkSchFilter) {
        return this.http.post(API.WORKORDER + "/GetTechWorkSchedule", techWorkSchFilter).pipe(map(resp => resp.json()));
    }
    getTechnicians(CompanyId: number, LogindId: number, VendorId: number, MaxRoleGroup: number): Observable<Technician[]> {
        return this.http.get(API.USER + "/GetTechAllDropDown/" + '?CompanyId=' + CompanyId +
            '&VendorId=' + VendorId +
            '&LoginId=' + LogindId +
            '&MaxRoleGroup=' + MaxRoleGroup +
            '&IsActive=' + 1).pipe(map(res => {
                var techs = <any>res.json();
                return techs;
            }));
    }
    //DeleteAwaitingJob
    deleteAwaitingJob(jobId: number, companyId: number, LoginId: number, WorkOrderId: number) {
        return this.http.delete(API.WORKORDER + "/DeleteAwaitingJob/" + jobId + "/" + companyId + "/" + LoginId + "/" + WorkOrderId).pipe(map(resp => resp.json()));
    }
    //GetAddjob
    getAddjob(jobId: number, companyId: number, woJobDetailsId: number) {
        return this.http.get(API.WORKORDER + "/GetAddjob/" + jobId + "/" + companyId + "/" + woJobDetailsId).pipe(map(resp => resp.json()));
    }
    //EditWoJob
    editWoJob(addEditWoJobEntity: woJobEditCFModel) {
        return this.http.post(API.WORKORDER + "/EditWoJobWithCF", addEditWoJobEntity).pipe(map(resp => resp.json()));
    }
    //AddWoJob
    addWoJob(addEditWoJobEntity: woJobCFModel) {
        return this.http.post(API.WORKORDER + "/AddWoJobWithCF", addEditWoJobEntity).pipe(map(resp => resp.json()));
    }

    getOptimisation(CompanyId: number) {
        return this.http.get(API.COMPANY + "/getOptimisation/" + CompanyId).pipe(map(resp => resp.json()));
    }

    /**Create WO Address Region */

    GetRegionfromServiceAddress(CompanyId: number, ServiceAddressId: number) {
        return this.http.get(API.CUSTOMER + "/GetRegionfromServiceAddress/" + CompanyId + "/" + ServiceAddressId).pipe(map(resp => resp.json()));
    }
    GetRegionforZip(CompanyId: number, CountryId: number, Zipcode: string) {
        return this.http.get(API.REGION + "/GetRegionforZip/" + CompanyId + "/" + CountryId + "/" + Zipcode).pipe(map(resp => resp.json()));
    }
    GetRegionforPolygon(CompanyId: number, Latitude: number, Longtitude: number, Zipcode: string, CountryId: number) {
        return this.http.get(API.REGION + "/GetRegionforPolygon/" + CompanyId + "/" + Latitude + "/" + Longtitude + "/" + + CountryId + "/" + Zipcode).pipe(map(resp => resp.json()));
    }
    GetCompany(companyId: number): Observable<Country> {
        return this.http.get(API.COMPANY + '/Get?CompanyId=' + companyId).pipe(map(res => res.json()));
    }
    //GetOnHoldStatus
    getOnHoldStatus(companyId: number, customerId: number): Observable<OnHoldStatus> {
        return this.http.get(API.CUSTOMER + "/GetOnHoldStatus/" + companyId + "/" + customerId).pipe(map(resp => resp.json()));
    }
    //GetAllowOnhold
    getAllowOnhold(companyId: number, settingsId: number) {
        return this.http.get(API.WORKORDER + "/GetAllowOnhold/" + companyId + "/" + settingsId).pipe(map(resp => resp.json()));
    }

    /**End Create WO Address Region */

    /**Save Custom Fields */
    insertCustomFields(CustomFields: CustomFieldsConfiguration) {
        // no response
        // .map<FPResponse>(resp => resp.json())
        return this.http.post(API.CUSTOMFILEDS + "/Insert?", CustomFields + "/" + null);
    }
    /**End Save Custom Fields */

    /**Update WorkOrder as Cancelled */
    CancelWOStatus(cancelWOstatus: CancelWOstatus): Observable<FPResponse> {

        return this.http.post(API.WORKORDER + "/CancelWOStatus", cancelWOstatus).pipe(map(res => res.json()));
    }
    /* Scheduling Preference */

    getSchedulingPrefValues(CompanyId: number): Observable<SchedulingPreference[]> {
        return this.http.get(API.SCHEDULINGPREFERENCE + "/" + CompanyId).pipe(map(res => res.json()));
    }
    UpdateWoStatus(CompanyId: number, WoId: number, StatusId: number) {
        return this.http.get(API.WORKORDER + "/UpdateWOStatus/" + CompanyId + "/" + WoId + "/" + StatusId).pipe(map(res => res.json()));
    }
    //CheckWorkOrderExist
    checkWorkOrderExist(CompanyId: number, WoId: string, IsTech: boolean, LoginId: number, MaxRoleGroup: number, VendorId: number, TypeId: number, IsManager: boolean) {
        return this.http.get(API.WORKORDER + "/CheckWorkOrderExist/" + WoId + "/" + CompanyId + "/" + IsTech + "/" + LoginId + "/" + MaxRoleGroup + "/" + VendorId + "/" + TypeId + "/" + IsManager).pipe(map(res => res.json()));
    }

    Quotesearch(CompanyId: number, QoId: string) {
        return this.http.get(API.QUOTE + "/Quotesearch/" + QoId + "/" + CompanyId + "/"  ).pipe(map(res => res.json()));
        }


    getSMSCount(CompanyId: number, MaxRoleGroupId: number, VendorId: number, TechId: number, Notification: number) {
        return this.http.get(API.WORKORDER + "/GetReceivedSMSLogCount/" + CompanyId + "/" + MaxRoleGroupId + "/" + VendorId + "/" + TechId + "/" + Notification).pipe(map(res => res.json()));
    }
    // getSMSCount(CompanyId: number, MaxRoleGroupId: number, VendorId: number, TechId: number) {
    //     return this.http.get(API.WORKORDER + "/GetReceivedSMSLogCount/" + CompanyId + "/" + MaxRoleGroupId + "/" + VendorId + "/" + TechId).pipe(map(res => res.json()));
    // }
    CancelJobStatus(cancelRemarks: Wojobstatus): Observable<FPResponse> {

        return this.http.post(API.WORKORDER + "/UpdateWOjobStatus", cancelRemarks).pipe(map(res => res.json()));
    }
    GetClosurePendingDetails(CompanyID: number, WorkOrdId: number, CusTimeZoneId: number): Observable<ClosurePendingDetails[]> {

        return this.http.get(API.WORKORDER + "/GetClosurePendingDetails/?CompanyId=" + CompanyID + "&WorkOrderId=" + WorkOrdId + "&CusTimeZoneId=" + CusTimeZoneId).pipe(map(resp => resp.json()));
    }

    //PT-1222 Added by anvardeen batcha
    //delete job task
    deleteJobTask(CompanyID: number, WoJobDetailsId: number, WorkTypeId: number, WorkTaskId: number, woJobId: number, CreatedBy: number) {


        return this.http.delete(API.WORKORDER + "/DeleteJobTask/" + CompanyID + "/" + WoJobDetailsId + "/" + WorkTypeId + "/" + WorkTaskId + "/" + woJobId + "/" + CreatedBy).pipe(map(resp => resp.json()));
    }

    checkPartrequest(CompanyId: number, WoJobId: number) {
        return this.http.get(API.PART + "/CheckPartRequestLists/" + CompanyId + "/" + WoJobId).pipe(map(resp => resp.json()));
    }

    saveOtherInfoCF(pkId: number, customFields: CustomFieldsConfiguration): Observable<FPResponse> {
        return this.http.post(API.CUSTOMFILEDS + '/Insert?PkId=' + pkId, customFields).pipe(map(res => res.json()));
    }
    saveWOrkorderOtherInfoCF(pkId: number, workorderCF: UpdateWorkorderCFModel): Observable<FPResponse> {
        return this.http.put(API.WORKORDER + '/UpdateWorkOrderDetails?PkId=' + pkId, workorderCF).pipe(map(res => res.json()));
    }
    GetEmailSmsLog(CompanyID: number, WorkOrdId: number, falg: number): Observable<Email[]> {
        return this.http.get(API.WORKORDER + "/GetEmailSmsLog/" + CompanyID + "/" + WorkOrdId + "/" + falg).pipe(map(resp => resp.json()));
    }

    getPartRequestList(CompanyId: number, WorkOrderId: number, WoJobId?: number) {
        return this.http.get(API.PART + "/GetPartRequestList/" + CompanyId + "/" + WorkOrderId + '/?WoJobId=' + WoJobId).pipe(map(resp => resp.json()));
    }

    getJobId(CompanyId: number, WorkOrderId: number) {
        return this.http.get(API.PART + "/GetJobId/" + CompanyId + "/" + WorkOrderId).pipe(map(resp => resp.json()));
    }

    getPartLookupList(filter: PartLookupFilter) {
        if (filter.vendorId != null) {
            return this.http.get(API.PART + "/GetPartLookupList/" + filter.CompanyID + '/?BrandId=' + filter.BrandId + '&ModelId=' + filter.ModelId + '&PartNo=' + filter.PartNo + '&Description=' + filter.Description + '&SortBy=' + filter.SortBy
                + '&OrderBy=' + filter.OrderBy + '&StartRecord=' + filter.StartRecord + '&EndRecord=' + filter.EndRecord + '&VendorId=' + filter.vendorId).pipe(map(resp => resp.json()));
        }
        else {
            return this.http.get(API.PART + "/GetPartLookupList/" + filter.CompanyID + '/?BrandId=' + filter.BrandId + '&ModelId=' + filter.ModelId + '&PartNo=' + filter.PartNo + '&Description=' + filter.Description + '&SortBy=' + filter.SortBy
                + '&OrderBy=' + filter.OrderBy + '&StartRecord=' + filter.StartRecord + '&EndRecord=' + filter.EndRecord).pipe(map(resp => resp.json()));
        }

    }

    getPartWareHouse(CompanyId: number, WoJobId: number) {
        return this.http.get(API.PART + "/GetPartWareHouse/" + CompanyId + "/" + WoJobId).pipe(map(resp => resp.json()));
    }

    getPartWareHouseQuantity(CompanyId: number, PartId: number, WarehouseId: number) {
        return this.http.get(API.PART + "/GetPartWareHouseQuantity/" + CompanyId + "/" + PartId + "/" + WarehouseId).pipe(map(resp => resp.json()));
    }

    getBrandList(CompanyId: number, vendorId?: number): Observable<BrandList[]> {
        return this.http.get(API.MODEL + '/GetBrandList/' + CompanyId + "/" + vendorId).pipe(map(res => res.json()));
    }

    // getModelList(CompanyId: number): Observable<ModelList[]> {
    //     return this.http.get(API.MODEL + '/GetModelList/' + CompanyId).map(res => res.json());
    // }

    getModelList(CompanyId: number, brandId: number): Observable<ModelList[]> {
        return this.http.get(API.PART + '/GetModelList/' + CompanyId + '/' + brandId).pipe(map(res => res.json()));
    }

    getSerialNumbers(CompanyId: number, PartId: number, WhId: number, SerialNo: string, StartRecord: number, EndRecord: number, SortBy: string, OrderBy: string, SerialNumber: SerialNumber[], LocationId?: number, BinId?: number): Observable<SerialNumberCount> {
        return this.http.put(API.PART + '/GetSerialNumbers/' + CompanyId + "/" + PartId + "/" + WhId + '/?SerialNo=' + SerialNo + '&StartRecord=' + StartRecord + '&EndRecord=' + EndRecord + "&SortBy=" + SortBy + "&OrderBy=" + OrderBy + "&LocationId=" + LocationId + "&BinId=" + BinId, SerialNumber).pipe(map(res => res.json()));
    }

    insertAllocatePartRequest(allocatepart: AllocatePart): Observable<SpErrors> {

        return this.http.post(API.PART + "/InsertAllocatePartRequest", allocatepart).pipe(map(res => res.json()));
    }
    GetOemPartReqAttachement(CompanyId: number, PartRequestId: number, FileName: string): Observable<Logo> {
        return this.http.get(API.COMPANY + "/GetOemPartReqAttachement/?CompanyId=" + CompanyId + "&PartRequestId=" + PartRequestId + "&FileName=" + FileName).pipe(map(res => res.json()));
    }
    getByPartRequest(CompanyId: number, PartRequestId: number, VendorId: number = null): Observable<PartRequest> {
        if (VendorId)
            return this.http.get(API.PART + '/GetByPartRequest/' + CompanyId + "/" + PartRequestId + "/" + VendorId).pipe(map(res => res.json()));
        else
            return this.http.get(API.PART + '/GetByPartRequest/' + CompanyId + "/" + PartRequestId).pipe(map(res => res.json()));
    }

    UpdatePartRequest(CompanyId: number, PartId: number[]): Observable<FPResponse> {
        return this.http.put(API.PART + "/UpdatePartRequest/" + CompanyId, PartId).pipe(map(res => res.json()));
    }

    UpdateallocatedPartRequest(CompanyId: number, loginid: number, PartRequest: PartRequestEntity[], SourceID: number): Observable<FPResponse> {
        return this.http.put(API.PART + "/UpdateallocatedPartRequest/" + CompanyId + "/" + loginid + '/?SourceID=' + SourceID, PartRequest).pipe(map(res => res.json()));
    }

    //Added by Anvardeen Batcha -- while job cancel check part request status
    getWOPartStatusCount(CompanyId: number, WorkOrderId: number, WoJobId: number): Observable<FPResponse> {
        return this.http.get(API.PART + "/GetWOPartStatusCount/" + CompanyId + "/" + WorkOrderId + "/" + WoJobId).pipe(map(res => res.json()));
    }
    //Added by Anvardeen Batcha -- while job cancel check part request status

    getPartReqStatus(CompanyId: number): Observable<PartReqStatus[]> {
        return this.http.get(API.PART + '/GetPartReqStatus/' + CompanyId).pipe(map(res => res.json()));
    }
    getCoreReturnStatus(CompanyId: number): Observable<CoreReturnStatus[]> {
        return this.http.get(API.PART + '/GetCoreReturnStatus/' + CompanyId).pipe(map(res => res.json()));
    }
    getAllRefOEMPartReqType(companyId: number): Observable<RefOEMPartReqType[]> {
        return this.http.get(API.PART + '/GetAllRefOEMPartReqType/' + companyId).pipe(map(res => res.json()));
    }
    CompanyWeekEnds(companyid: number): Observable<CompanyWeekends> {
        return this.http.get(API.DISPATCHBOARD + "/CompanyWeekEnds/" + companyid).pipe(map(res => res.json()));
    }

    DispatchSetting(companyId: number): Observable<DispatchSetting[]> {
        return this.http.get(API.DISPATCHBOARD + "/DispatchHolidaySetting/" + companyId).pipe(map(res => res.json()));
    }
    TechArroundValue(companyId: number): Observable<DispatchSetting> {
        return this.http.get(API.DISPATCHBOARD + "/TechArroundValue/" + companyId).pipe(map(res => res.json()));
    }

    getHoliday(CompanyId: number[], year: number): Observable<Holiday[]> {
        return this.http.put(API.HOLIDAY + "/GetCurrentYearHolidays/" + year, CompanyId).pipe(map(res => res.json()));
    }

    getProjects(CompanyId: number, CustomerId: number) {
        return this.http.get(API.PROJECT + "/GetProjects/" + CompanyId + "/" + CustomerId).pipe(map(resp => resp.json()));
    }

    getVendorList(CompanyId: number, LoginId: number, MaxRoleGroup: number, ProjectId: number, VendorId?: number): Observable<Vendor[]> {
        return this.http.get(API.USER + "/GetVendorList/" + CompanyId + "/" + LoginId + "/" + MaxRoleGroup + "/?ProjectId=" + ProjectId + '&VendorId=' + VendorId).pipe(map(res => res.json()));
    }

    GetJobStatus(companyId: number) {
        return this.http.get(API.WOCOMPANYMASTER + '/GetMasterEntityJobStatus/?CompanyId=' + companyId).pipe(map(resp => resp.json()));
    }
    getCustomerTime(CusTimeZoneId: number): Observable<CustomerTimeZone> {
        return this.http.get(API.WORKORDER + '/GetCustomerTimeZone/' + CusTimeZoneId).pipe(
            map(resp => resp.json()));

    }
    UpdateWorkorderCPDetails(entity: CPUpdateDetails): Observable<any> {
        return this.http.put(API.WORKORDER + '/UpdateWorkorderCPDetails', entity).pipe(
            map(resp => resp.json()));
    }
    GetAllStatusReason(CompanyId: number, CPRequestStatusId: number): Observable<CPStatusReasonDD[]> {
        return this.http.get(API.WORKORDER + '/GetAllStatusReason/' + CompanyId + '/' + CPRequestStatusId).pipe(
            map(resp => resp.json()));

    }
    getConfig(CompanyId: number, Id: number): Observable<Config[]> {
        return this.http.get(API.CONFIGMASTER + "/GetAll/" + CompanyId + "/" + Id).pipe(map(res => res.json()));
    }
    SaveSla(saveSla: SLAEntity): Observable<FPResponse> {

        return this.http.post(API.WORKORDER + "/SaveJobSLA", saveSla).pipe(map(res => res.json()));
    }

    getTransferHistory(BrandId: number, ModelId: number, pagerList: PagerList): Observable<TransferHistList> {
        if (pagerList.SearchBy) {
            return this.http.get(API.ASSETTRANSFER + "/GetEquipmentTransferHist?CompanyId=" + pagerList.CompanyId + "&BrandId=" + BrandId + "&ModelId=" + ModelId + "&SearchBy=" + pagerList.SearchBy + "&SortBy=" + pagerList.SortBy + "&OrderBy=" + pagerList.OrderBy + "&startRecord=" + pagerList.StartRecord + "&EndRecord=" + pagerList.EndRecord).pipe(map(resp => resp.json()));

        }
        else {
            return this.http.get(API.ASSETTRANSFER + "/GetEquipmentTransferHist?CompanyId=" + pagerList.CompanyId + "&BrandId=" + BrandId + "&ModelId=" + ModelId + "&SortBy=" + pagerList.SortBy + "&OrderBy=" + pagerList.OrderBy + "&startRecord=" + pagerList.StartRecord + "&EndRecord=" + pagerList.EndRecord).pipe(map(resp => resp.json()));

        }
    }
    //Assign Partner - Added by Anvardeen Batcha B
    updateJobAssignVendor(CompanyId: number, JobId: number, VendorId: number, VendorAssignRemarks: string, LastChangedBy: number,IsQuote: number, QuoteOrderId?: number): Observable<FPResponse> {
        if(IsQuote)
        return this.http.put(API.QUOTE + "/UpdateJobAssignPartner/?CompanyId=" + CompanyId + "&JobId=" + JobId + "&VendorId=" + VendorId + "&VendorAssignRemarks=" + VendorAssignRemarks + "&LastChangedBy=" + LastChangedBy+ "&QuoteOrderId=" + QuoteOrderId, null).pipe(map(resp => resp.json()));
        else
        return this.http.put(API.WORKORDER + "/UpdateJobAssignPartner/?CompanyId=" + CompanyId + "&JobId=" + JobId + "&VendorId=" + VendorId + "&VendorAssignRemarks=" + VendorAssignRemarks + "&LastChangedBy=" + LastChangedBy, null).pipe(map(resp => resp.json()));
    }
    //Assign Partner - Added by Anvardeen Batcha B

    getTaxGroup(CompanyId: number, TaxTypeId: number): Observable<TaxGroup[]> {
        return this.http.get(API.TAXGROUPMASTER + "/GetTaxGroup/?CompanyId=" + CompanyId + '&TaxTypeId=' + TaxTypeId).pipe(map(res => res.json()));
    }

    getTax(CompanyId: number, TaxId: number) {
        return this.http.get(API.TAXMASTER + '/GetById/' + CompanyId + '/' + TaxId).pipe(map(res => res.json()));
    }

    getTaxGroupbyId(CompanyId: number, TaxGroupId: number) {
        return this.http.get(API.TAXGROUPMASTER + '/GetTaxgroupPercent/' + CompanyId + '/' + TaxGroupId).pipe(map(res => res.json()));
    }
    getSMSLog(getSMSLogsearch: GetSMSLogSearch, pagerList: Pagination): Observable<GetSMSLogList> {
        if (pagerList.SearchBy) {
            return this.http.post(API.WORKORDER + "/GetSMSLog?CompanyId=" + pagerList.CompanyId + "&SearchBy=" + pagerList.SearchBy + "&SortBy=" + pagerList.SortBy + "&OrderBy=" + pagerList.OrderBy + "&startRecord=" + pagerList.startRecord + "&EndRecord=" + pagerList.EndRecord, getSMSLogsearch).pipe(map(resp => resp.json()));
        }
        else {
            return this.http.post(API.WORKORDER + "/GetSMSLog?CompanyId=" + pagerList.CompanyId + "&SortBy=" + pagerList.SortBy + "&OrderBy=" + pagerList.OrderBy + "&startRecord=" + pagerList.startRecord + "&EndRecord=" + pagerList.EndRecord, getSMSLogsearch).pipe(map(resp => resp.json()));
        }
    }
    getSmsLog(companyId: number, jobId: number): Observable<SmslogEntity[]> {
        return this.http.get(API.DISPATCHBOARD + "/GetSmslog/" + companyId + '/' + jobId).pipe(map(res => res.json()));
    }
    GetAllCPRequestStatus(companyId: number): Observable<RefCPRequestStatusComp[]> {
        return this.http.get(API.STATUSREASON + '/GetAllCPRequestStatus/' + companyId).pipe(map(res => res.json()));
    }

    GetManagerTech(CompanyId: number, LoginId: number): Observable<number[]> {
        return this.http.get(API.WORKORDER + '/GetManagerTech/' + CompanyId + "/" + LoginId).pipe(map(res => res.json()));
    }

    getBusinessHour(companyId: number): Observable<BusinessHour[]> {
        return this.http.get(API.COMPANY + '/GetBusinessHour?CompanyId=' + companyId).pipe(map(res => res.json()));
    }

    getCustomerTypeBusinessHour(companyId: number, CustomerTypeId: number): Observable<CTBusinessHour[]> {
        return this.http.get(API.CUSTOMERTYPE + '/GetBusinessHour/' + companyId + '/' + + CustomerTypeId).pipe(map(res => res.json()));
    }

    getHolidays(CompanyId: number): Observable<Holiday[]> {
        return this.http.get(API.HOLIDAY + "/GetAll/" + CompanyId).pipe(map(res => {
            var holid = <any>res.json();

            return holid.HolidaysList;
        }));

    }
    CheckInHouseJob(CompanyId: number, WoJobId: number): Observable<number> {
        return this.http.get(API.WORKORDER + '/CheckInHouseJob/' + CompanyId + "/" + WoJobId).pipe(map(res => res.json()));
    }
    getBusinessHours(companyId: number, customerId: number): Observable<CustomerBusinessHour[]> {

        return this.http.get(API.CUSTOMER + '/GetBusinessHour?CompanyId=' + companyId + '&CustomerId=' + customerId).pipe(map(res => res.json()));
    }
    validatePreferredDate(preferredDate: string, customerId: number, companyId: number, timeSlotId: number): Observable<boolean> {

        return this.http.get(API.WORKORDER + '/ValidatePreferredDate?PreferredDate=' + preferredDate + '&CustomerId=' + customerId + '&CompanyId=' + companyId + '&TimeSlotId=' + timeSlotId).pipe(map(res => res.json()));
    }

    getCompany(companyId: number): Observable<Company> {
        return this.http.get(API.COMPANY + '/Get/?CompanyId=' + companyId).pipe(map(res => res.json()));
    }

    InsertUpdateBOQPartRequest(Entity: BOQPartsEntity) {
        return this.http.post(API.PART + "/InsertUpdateBOQPartRequest", Entity).pipe(map(res => res.json()));
    }

    getSmsReceivedLog(CompanyId: number, MaxRoleGroupId: number, VendorId: number, TechId: number, TimeZoneId: number, Notification: number): Observable<SmsLogReceived[]> {
        return this.http.get(API.WORKORDER + "/GetReceivedSMSLog/?CompanyId=" + CompanyId + '&MaxRoleGroupId=' + MaxRoleGroupId + '&VendorId=' + VendorId + '&TechId=' + TechId + "&TimeZoneId=" + TimeZoneId + "&Notification=" + Notification).pipe(map(res => res.json()));
    }

    getEMailLogs(getSMSLogsearch: GetSMSLogSearch, pagerList: Pagination): Observable<GetEMailLogList> {
        if (pagerList.SearchBy)
            return this.http.post(API.WORKORDER + "/GetEMailLog?CompanyId=" + pagerList.CompanyId + "&SearchBy=" + pagerList.SearchBy + "&SortBy=" + pagerList.SortBy + "&OrderBy=" + pagerList.OrderBy + "&startRecord=" + pagerList.startRecord + "&EndRecord=" + pagerList.EndRecord, getSMSLogsearch).pipe(map(resp => resp.json()));
        else
            return this.http.post(API.WORKORDER + "/GetEMailLog?CompanyId=" + pagerList.CompanyId + "&SortBy=" + pagerList.SortBy + "&OrderBy=" + pagerList.OrderBy + "&startRecord=" + pagerList.startRecord + "&EndRecord=" + pagerList.EndRecord, getSMSLogsearch).pipe(map(resp => resp.json()));

    }

    getEmailLog(companyId: number, jobId: number): Observable<SmslogEntity[]> {
        return this.http.get(API.DISPATCHBOARD + "/getEmailLog/" + companyId + '/' + jobId).pipe(map(res => res.json()));
    }

    PDFConvert(companyId: number, WorkorderId: number, wojobid: number, TechId: number, MailAddress: string, ScreenDetails: string): Observable<FPResponse> {
        return this.http.get(API.WOPDFMAIL + '/GetTechJobReportPDFMail/' + companyId + "/" + WorkorderId + "/" + wojobid + "/" + TechId + "/" + MailAddress + "/" + ScreenDetails).pipe(map(res => res.json()));
    }

    getIotAlerts(): Observable<IOTWebhookEntity[]> {
        return this.http.get(API.IOTORDER + '/GetIotAlerts').pipe(map(res => res.json()));
    }

    GetLinkedWoInfo(CompanyId: number, WorkOrderId: number): Observable<LinkedWorkOrders> {
        return this.http.get(API.WORKORDER + "/GetLinkedWoInfo/" + CompanyId + "/" + WorkOrderId).pipe(map(resp => resp.json()));
    }

    GetProjectDetailsPanel(CompanyId: number, WorkorderId: number): Observable<ProjectDetailsPanelEntity> {
        return this.http.get(API.PROJECT + '/GetProjectDetailsPanel/' + CompanyId + '/' + WorkorderId).pipe(map(res => res.json()));
    }
    GetReasonStatus(CompanyId: number, IsActive: number, SortBy: string, OrderBy: string, startRecord: number, EndRecord: number, WorkTypeIds: any): Observable<JobStatusReasonEntity> {
        return this.http.get(API.STATUSREASON + '/GetAll/' + '?CompanyId=' + CompanyId + '&IsActive=' + IsActive + '&SortBy=' + SortBy + '&OrderBy=' + OrderBy + '&startRecord=' + startRecord + '&EndRecord=' + EndRecord + '&WorkTypeIds=' + JSON.stringify(WorkTypeIds)).pipe(map(res => res.json()));
    }
    UpdateStatusReason(Model: StatusReasonEntity): Observable<FPResponse> {
        return this.http.post(API.STATUSREASON + "/UpdateStatusReason", Model).pipe(map(resp => resp.json()));
    }

    DeleteAttachmentFile(model: FileDetails[]) {

        return this.http.post(API.WORKORDER + '/DeleteWOFile/', model).pipe(map(res => res.json()));
    }

    getUserRoles(companyId: number, loginid: number): Observable<UserRoles[]> {
        return this.http.get(API.COMMON + '/GetUserRoles/' + companyId + '/' + loginid).pipe(map(res => res.json()));

    }

    getWorkTaskAllottedChecklist(CompanyId: number, WorkTaskId: number): Observable<Checklist[]> {
        return this.http.get(API.WOMASTER + '/GetAllottedChecklist?CompanyId=' + CompanyId + '&WorkTaskId=' + WorkTaskId).pipe(map(res => res.json()));
    }

    getMapSettings(): Observable<any> {
        return this.httpClient.get<any>('assets/json/map-settings.json');
    }

    getJobStatusPopupList(jobStatusPopupInputSearchEntity: JobStatusPopupInputSearchEntity, SortBy: string, OrderBy: string, startRecord: number, EndRecord: number): Observable<ResponseJobStatusPopupList> {       
        return this.http.post(API.WORKORDERCUSTOMEPORTAL + '/GetJobStatusPopupDeatils/' + '?SortBy=' + SortBy + '&OrderBy=' + OrderBy + '&startRecord=' + startRecord + '&EndRecord=' + EndRecord, jobStatusPopupInputSearchEntity).pipe(map(res => res.json()));
    }
    getCustomerVendorList(CompanyId: number, LoginId: number, MaxRoleGroup: number, ProjectId: number,CustomerId: number, VendorId?: number): Observable<Vendor[]> {
        return this.http.get(API.USER + "/GetCustomerVendorList/" + CompanyId + "/" + LoginId + "/" + MaxRoleGroup + "/"+ CustomerId + "/?ProjectId=" + ProjectId + '&VendorId=' + VendorId).pipe(map(res => res.json()));
    }

    getAssociatedVendors(CompanyId: number, CustomerId: number): Observable<any[]> {
        return this.http.get(API.WORKORDER + '/GetAssociatedVendors?CompanyId=' + CompanyId + '&CustomerId=' + CustomerId).pipe(map(res => res.json()));
    }
    GetCustomerVendorList(CompanyId: number,LoginId:number, CustomerId: number): Observable<any[]> {
        return this.http.get(API.QUOTE + '/GetCustomerVendorList?CompanyId=' + CompanyId + '&LoginId='+ LoginId + '&CustomerId=' + CustomerId).pipe(map(res => res.json()));
    }
    DeleteWoFormsAttachment(CompanyId: number, UniqueId: number) {
        return this.http.get(API.WORKORDER + '/DeleteWoFormsAttachment/' + CompanyId + '/' + UniqueId).pipe(
            map(res => res.json()));
    }
    getPricingDetails(companyId: number, woJobId: number): Observable<PricingModel[]> {
        return this.http.get(API.WORKORDER + "/GetWoJobPriceDetails" + "?CompanyId=" + companyId + "&woJobId=" + woJobId).pipe(
            map(res => res.json()));
    }
    GetProjectMilestoneList(CompanyId: number, ProjectId: number) {
        return this.http.get(API.PROJECT + "/GetProjectMilestoneList/" + CompanyId + "/" + ProjectId).pipe(map(resp => resp.json()));
    }
}